export default __webpack_public_path__ + "static/media/terasse-1.b47872b7.jpeg";